import { MobileBaseField } from '../BaseField/models';
import debounce from 'lodash.debounce';
import { AcceptanceValue, ReadingMethod } from '../constants';

const successAudio = new Audio(`${STATIC_URL}i/success.mp3`);
const errorAudio = new Audio(`${STATIC_URL}i/error.mp3`);
export const debouncedSuccess = debounce(() => {
    successAudio.play();
}, 100);

export const debouncedError = debounce(() => {
    errorAudio.play();
}, 100);

export const playAcceptanceValueSound = (reading, acceptanceValue) => {
    if (reading === ReadingMethod.PROBE) {
        if (acceptanceValue === AcceptanceValue.PASS) {
            debouncedSuccess();
        } else if (acceptanceValue === AcceptanceValue.FAIL) {
            debouncedError();
        }
    }
};

export const MobileTemperatureField = MobileBaseField.extend({
    validation: {
        value: {
            pattern: 'number',
            required: function (val, attr, attrs) {
                return this._is_required(val, attr, attrs);
            }
        }
    },

    // don't copy the value for media fields on autofill copy
    get_attributes_for_autofill: function () {
        return {};
    },

    /**
     * Get the max id available pulling ids from the ingredient catalog
     * and the current available ingredients in the model
     */
    getMaxId: function (fields_catalog) {
        const catalogIds = fields_catalog.pluck('id');
        const ingredientIds = this.collection.pluck('id');
        const uniqIds = _.uniq([...catalogIds, ...ingredientIds]).sort();
        return _.max(uniqIds) + 1;
    },

    getLastIndex: function () {
        const originalId = this.get('retemp_original_id');

        if (!originalId) {
            return this.collection.indexOf(this);
        }

        const allRetemps = this.collection.where({ retemp_original_id: originalId });
        const lastRetemp = allRetemps[allRetemps.length - 1];

        return this.collection.indexOf(lastRetemp);
    },
    set_acceptance_value: function (use_silent_update) {
        MobileBaseField.__super__.set_acceptance_value.apply(this, [use_silent_update]);
        if ($f.flags.get_flag('pass_fail_temperature_audio')) {
            playAcceptanceValueSound(this.get('reading_method'), this.get('acceptance_value'));
        }
    },
    /**
     * Copying attributes for new retemp fields using clone/cloneDeep causes the app to have
     * huge memory spikes this is the safes way we can provide a new copy of attributes
     * without having to worry about memory usage.
     */

    getAttributesCopy: function () {
        return JSON.parse(JSON.stringify(this.attributes));
    },

    addRetempAttemptField: function () {
        const type = this.get('type');
        const originalField = this.collection.get(this.get('retemp_original_id') || this.get('id'));
        // Get the latest id available in the collection to be used on the next attempt.
        const field_catalog =
            type === 'equipment_temperature'
                ? this.collection.equipment_collection
                : this.collection.ingredients_catalog;

        const maxId = this.getMaxId(field_catalog);
        if (!this.collection.form_collection) {
            return;
        }

        const parentId = this.collection.parent_field_id;
        const ingredientFormModel = this.collection.form_collection.findWhere({ id: parentId });
        const allowedRetemps = ingredientFormModel.get_metadata_attribute('allowed_retemps');

        if (allowedRetemps === undefined) {
            return;
        }
        const retempAttemptNumber = this.get('retemp_attempt_number') ? this.get('retemp_attempt_number') + 1 : 1;

        if (retempAttemptNumber > allowedRetemps) {
            return;
        }

        if (this.get('retemp_original_id') === undefined) {
            this.is_original_field = true;
        }

        const newRetempModel = {
            ...this.getAttributesCopy(),
            acceptance_value: null,
            follow_up_actions: null,
            id: maxId + 1,
            retemp_attempt_number: retempAttemptNumber,
            value: null,
            retemp_original_id: originalField.get('id'),
            required: true
        };

        const name_key = type === 'equipment_temperature' ? 'model_name' : 'name';
        newRetempModel[name_key] = `${originalField.get(name_key)} Retemp #${retempAttemptNumber}`;

        this.collection.add(newRetempModel, {
            at: this.getLastIndex() + 1
        });
    },

    removeRetempAttempts: function () {
        const toRemoveModels = this.collection.filter((model) => model.get('retemp_original_id') === this.id);
        this.collection.remove(toRemoveModels);
    },

    removeRetempAttemptsFromCurrentId: function () {
        const lastRetempIdx = this.getLastIndex();
        const lastRetemp = this.collection.at(lastRetempIdx);
        const toRemoveModels = this.collection.filter(
            (model) =>
                model.id > this.id &&
                model.id <= lastRetemp.id &&
                model.get('retemp_original_id') === this.get('retemp_original_id')
        );
        this.collection.remove(toRemoveModels);
    }
});
